import Api from '../../../../../../../commons/api/index';

export const getVenueTransactions = async () => {
  try {
    const response = await Api.get('/venues');
    return response?.data;
  } catch (error) {
    console.error('Error getting getVenueTransactions', error);
  }
  return null;
};

export const getEventsByVenue = async (filters) => {
  try {
    const response = await Api.post('/events/events/filter', filters);
    if (Array.isArray(response?.data)) return response?.data;
  } catch (error) {
    console.error('Error getting getEventsbyVenue', error);
  }
  return null;
};

export const getUserOwner = async (idUser) => {
  try {
    const response = await Api.get(`/vendor-events/vendor-events/find-user-owner/${idUser}`);
    if (response?.data) return response?.data;
  } catch (error) {
    console.error('Error getting getUserOwner', error);
  }
  return null;
};

export const getVenueById = async (venueId) => {
  try {
    const response = await Api.get(`/venues/venues/${venueId}`);
    if (response?.data) return response?.data;
  } catch (error) {
    console.error('Error getting getVenueById', error);
  }
  return null;
};

export const findStripeTransfers = async (eventId) => {
  try {
    const response = await Api.get(`/vendor-events/vendor-events/find-stripe-transfers/${eventId}`);
    if (response?.data) return response?.data;
  } catch (error) {
    console.error('Error getting findStripeTransfers', error);
  }
  return null;
};

export const findStripePayments = async (eventId) => {
  try {
    const response = await Api.get(`/vendor-events/vendor-events/find-stripe-payments/${eventId}`);
    if (response?.data) return response?.data;
  } catch (error) {
    console.error('Error getting findStripePayments', error);
  }
  return null;
};
